import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import Hero from "@/components/sections/Hero";
import Stats from "@/components/sections/Stats";
import WhyChoose from "@/components/sections/WhyChoose";
import Services from "@/components/sections/Services";
import Destinations from "@/components/sections/Destinations";
import TestPrep from "@/components/sections/TestPrep";
import Process from "@/components/sections/Process";
import Testimonials from "@/components/sections/Testimonials";
import Gallery from "@/components/sections/Gallery";
import FAQs from "@/components/sections/FAQs";
import LocalSEO from "@/components/sections/LocalSEO";
import Founder from "@/components/sections/Founder";
import Contact from "@/components/sections/Contact";

export default function Home() {
  useEffect(() => {
    document.title = "Best Overseas Education Consultants in Hyderabad | IELTS, PTE, Spoken English Coaching in Santosh Nagar — Globe Vista";
    const desc =
      "Globe Vista is Hyderabad's leading overseas education consultant and the best IELTS, PTE and Spoken English coaching in Santosh Nagar. Study abroad support for UK, USA, Canada, Australia, NZ, Ireland, Germany.";
    const keywords =
      "best overseas education consultant in Hyderabad, best IELTS coaching in Hyderabad, best IELTS classes in Hyderabad, best IELTS classes in Santosh Nagar, best IELTS training in Santosh Nagar, best PTE coaching in Hyderabad, best PTE training in Santosh Nagar, best PTE classes in Santosh Nagar, best PTE training in Hyderabad, best spoken english classes in Hyderabad, best spoken english classes in Santosh Nagar, best spoken english coaching in Santosh Nagar, best spoken english coaching in Hyderabad, IELTS training near me, PTE training near me, study abroad consultants Hyderabad, study in UK, study in Canada, study in Australia";

    const setMeta = (name, content, attr = "name") => {
      let m = document.querySelector(`meta[${attr}="${name}"]`);
      if (!m) {
        m = document.createElement("meta");
        m.setAttribute(attr, name);
        document.head.appendChild(m);
      }
      m.setAttribute("content", content);
    };

    setMeta("description", desc);
    setMeta("keywords", keywords);
    setMeta("robots", "index, follow");
    setMeta("og:title", "Globe Vista Overseas Education — Best IELTS, PTE & Study Abroad in Hyderabad", "property");
    setMeta("og:description", desc, "property");
    setMeta("og:type", "website", "property");
    setMeta("twitter:card", "summary_large_image");

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = window.location.origin + "/";

    // Rich schema graph: EducationalOrganization + LocalBusiness + WebSite (SearchAction)
    const schema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": ["EducationalOrganization", "LocalBusiness"],
          "@id": window.location.origin + "/#org",
          name: "Globe Vista Overseas Education",
          alternateName: "Globe Vista",
          description: desc,
          url: window.location.origin,
          telephone: "+917416807560",
          email: "Globevistaoverseasedu@gmail.com",
          image: window.location.origin + "/logo192.png",
          founder: {
            "@type": "Person",
            name: "Syed Moinuddin",
            jobTitle: "Founder & Lead Trainer",
            image: "https://customer-assets-39nsmqrw.emergentagent.net/job_visa-to-dreams/artifacts/cxot8aox_Snapchat-1025997663.jpg",
          },
          address: {
            "@type": "PostalAddress",
            streetAddress: "Santosh Nagar",
            addressLocality: "Hyderabad",
            addressRegion: "Telangana",
            postalCode: "500059",
            addressCountry: "IN",
          },
          areaServed: [
            { "@type": "City", name: "Hyderabad" },
            { "@type": "Place", name: "Santosh Nagar" },
            { "@type": "AdministrativeArea", name: "Telangana" },
          ],
          knowsAbout: keywords.split(",").map((s) => s.trim()),
          priceRange: "₹6,000 - ₹28,000",
          openingHoursSpecification: {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            opens: "09:00",
            closes: "20:00",
          },
          sameAs: ["https://www.instagram.com/globevistaoverseas"],
        },
        {
          "@type": "WebSite",
          url: window.location.origin,
          name: "Globe Vista Overseas Education",
          potentialAction: {
            "@type": "SearchAction",
            target: window.location.origin + "/blog?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        },
      ],
    };
    let s = document.getElementById("gv-schema");
    if (!s) {
      s = document.createElement("script");
      s.id = "gv-schema";
      s.type = "application/ld+json";
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(schema);
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <WhyChoose />
        <Services />
        <Destinations />
        <TestPrep />
        <Process />
        <Testimonials />
        <Gallery />
        <FAQs />
        <LocalSEO />
        <Contact />
        <Founder />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
